import React, { useEffect } from 'react'
import InviteInterpreterList from './InviteInterpreterTable'
import { useParams } from 'react-router-dom'
import { fetchAppointmentView } from 'slices/appointmentSlice'
import { useDispatch } from 'react-redux'

const InviteInterpreter = () => {
    const dispatch = useDispatch()
    const { id } = useParams()
    const [item, setItem] = React.useState({});
    useEffect(() => {
        const callBack = (success, message, data) => {
            if (success) {
                setItem(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchAppointmentView(id, callBack))
    }, [id])

    return (

        <InviteInterpreterList itemId={id} appointmentData={item}/>
    )
}

export default InviteInterpreter